export default (value) => (!value ? value : value.replace(/[_-]/g, '').trim());
